import { globalErrorMsg } from '@bingads-webui-campaign/hotel-common-upsert';
import { validateBidAdjustment, isValueOverlap } from '../components/utility';
import { validateCheckinDate } from './utility';

export function getCheckinDateBasicConfig(i18n) {
  const columns = [
    {
      key: 'start-date', name: i18n.getString(_TL_('Start check-in date')), fieldName: 'startDate', minWidth: 200, maxWidth: 245, type: 'datePicker', className: 'border-right', headerClassName: 'target-custom-header',
    },
    {
      key: 'end-date', name: i18n.getString(_TL_('End check-in date')), fieldName: 'endDate', minWidth: 200, maxWidth: 240, type: 'datePicker', className: 'border-right', headerClassName: 'target-custom-header',
    },
  ];
  return {
    basicConfig: {
      columns,
      showAddBtn: true,
      showSettingToggle: true,
      titleKey: i18n.getString(_TL_('Check-in date')),
      topicKey: 'pop_BA_CampaignTargets_CheckinDate',
      extraClass: 'checkin-date-container',
      maxLimit: 30,
      minBid: -90,
      maxBid: 900,
      extraBid: [-100],
    },
  };
}


export const checkinDateDefaultSetting = [{
  startDate: '',
  endDate: '',
  bidAdjustmentDropdown: 'Increase by',
  bidAdjustmentInput: 0,
}];


export const isCheckinDateTargetValid = (checkinDate, patchErrMsg = function () { }) => {
  let isValid = true;

  checkinDate.filter(item => item.Status !== 'Deleted').forEach((item) => {
    let validateValue = item.bidAdjustmentInput;
    if (item.bidAdjustmentDropdown === 'Decrease by') {
      validateValue = -validateValue;
    }
    if (validateBidAdjustment({
      value: validateValue, min: -90, max: 900, extra: [-100],
    }) || validateCheckinDate({ value: item.startDate }) || validateCheckinDate({ value: item.endDate })) {
      isValid = false;
    }
  });
  if (isValueOverlap('checkinDate', checkinDate)) {
    isValid = false;
  }
  if (isValid) {
    patchErrMsg('checkinDate', '');
  } else {
    patchErrMsg('checkinDate', globalErrorMsg);
  }
  return isValid;
};
